'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var UserSecureConfig = function UserSecureConfig($rootScope, $location, $urlRouter, userSecureService, $state, $cookies, $log, featureToggleService, landingPageConstants) {
  var changedValue = [];
  function renderView(toState, toParams, fromState, fromParams) {
    $state.go(toState.name, toParams, {
      notify: false
    }).then(function () {
      $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
    });
  }
  function isAccessible(viewName, nextState, fromState, eventArguments) {
    var isScreenEnabledBasedOnFeature = featureToggleService.isEnabledBasedOnConfig(nextState);
    if (userSecureService.hasAuthorization(viewName) && isScreenEnabledBasedOnFeature) {
      renderView.apply(undefined, eventArguments);
    } else {
      var errorMsg = 'User does not have permission for workflow ' + viewName.toUpperCase();
      $log.error('UserSecureConfig: isAuthorized - ' + errorMsg);
      toastr.error(errorMsg);
      if (fromState.name === nextState.name || fromState["abstract"]) {
        $state.go('app.dashboard');
      }
    }
  }
  $rootScope.$on('getChangedValue', function (event, change) {
    changedValue = change;
  });
  $rootScope.$on('$stateChangeStart', function (evt, nextState, nextParams, fromState) {
    evt.preventDefault();
    var qs = $location.search();
    var eventArguments = Array.prototype.slice.call(arguments, 1);
    var stateView = _.kebabCase(nextState.name.replace('app.', ''));
    var currentUser = userSecureService.getCurrentUser();
    if (changedValue.length !== 0) {
      return $rootScope.$broadcast('save-modal:openModal', nextState, fromState);
    }
    if (!sessionStorage.getItem('carrierCode') && currentUser.organization === 'SG' && nextState.name !== 'app.select-carrier') {
      return $state.go('app.select-carrier', {
        nextState: nextState
      });
    }
    if (nextState.name === 'app.select-carrier' && !sessionStorage.getItem('carrierCode')) {
      return renderView.apply(this, eventArguments);
    }
    if (!_.get(currentUser, 'isActive') && nextState.name !== 'app.user-landing') {
      return $state.go('app.user-landing');
    }
    if (nextState.name === 'app.dashboard' && !qs.authToken) {
      var landingPage = _.find(landingPageConstants, featureToggleService.isEnabledBasedOnConfig);
      eventArguments[0].name = landingPage.name;
      eventArguments[0].url = landingPage.url;
      return renderView.apply(this, eventArguments);
    }
    if (nextState.name === 'app.user-landing') {
      return renderView.apply(this, eventArguments);
    }
    if (nextState.name === 'app.user-profile') {
      return renderView.apply(this, eventArguments);
    }
    if (qs.authToken) {
      userSecureService.retrieveUserData(qs.authToken).then(function () {
        isAccessible(stateView, nextState, fromState, eventArguments);
      });
    } else {
      isAccessible(stateView, nextState, fromState, eventArguments);
    }
  });
};
UserSecureConfig.$inject = ['$rootScope', '$location', '$urlRouter', 'UserSecureService', '$state', '$cookies', '$log', 'FeatureToggleService', 'LandingPageConstants'];
module.exports = UserSecureConfig;